import { Injectable } from '@angular/core';

import {Http, Response, URLSearchParams} from '@angular/http'

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class ScoreboardService {

  private lastDataScoreboardUrl = '/api/scoreboard/last_topic_data';
  private validateScoreboardUrl = '/api/scoreboard/validate_topic';
  private validateInningUrl = '/api/scoreboard/validate_inning';

  constructor(private http: Http) { }

  getLastScoreboardData(topic: any): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('topic', topic);
    return this.http.get(this.lastDataScoreboardUrl, {params: params}).map(response => {
      return response.json()
    });
  }

  validateScoreboardTopic(topic: any): Promise<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('topic', topic);
    return this.http.get(this.validateScoreboardUrl, {params: params}).toPromise().then(response => {
      return response.json().validate
    }, ()=>{
      return false;
      });
  }

  validateInning(topic: any, inning: any): Promise<any> {
    let params: URLSearchParams = new URLSearchParams();
    params.set('topic', topic);
    params.set('inning', inning);
    return this.http.get(this.validateInningUrl, {params: params}).toPromise().then(response => response.json().exist);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/scoreboard.service.ts